/**
 * Strips the size unit as number if needed (ex: '40px' returns 40)
 * @param {*} size
 */
export function getSizeValue(size = '') {
    const SIZE_REGEX = /^([1-9]\d+)([a-zA-Z]+)?$/i;
    const match = size.match(SIZE_REGEX);

    return match ? Number(match[1]) : 0;
}

/**
 * Adds default unit 'px' if needed (ex: '40' returns '40px')
 * @param {*} size
 */
export function getFormattedSize(size) {
    if (!size) {
        return size;
    }

    const FULLY_QUALIFIED_SIZE_REGEX = /^([1-9]\d+)(em|ex|px|cm|mm|in|pt|pc)$/i;
    const match = size.match(FULLY_QUALIFIED_SIZE_REGEX);

    return match ? size : `${size}px`;
}
